import React, { useEffect, useState } from "react";
import "./style.css";
import request from "../../shared/utils/request";
import { Loader } from "../../shared/components/loader";
import RazorpayPayment from "../../shared/components/razorpay";

const PaymentPage = () => {
  const [courseData, setCourseData] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getCourseDetails();
  }, []);

  const getCourseDetails = async () => {
    setLoader(true);
    const response = await request.get("student/getStudentCourse");
    if (response) {
      if (response?.data?.data?.student?.payment_status === "Completed") {
        window.location.href = "/student/dashboard";
      } else {
        setCourseData(response?.data?.data?.course);
        setStudentData(response?.data?.data?.student);
        setLoader(false);
      }
    }
  };

  return (
    <section id="services" classname="services section">
      <div classname="container">
        <div className="container">
          <div className="text-center mb-3">
            <h1 className="display-4 fw-bold mb-3">Course Overview</h1>
            <p className="lead text-muted col-lg-8 mx-auto">
              Secure your spot and start learning today!
            </p>
          </div>
          <Loader isLoading={loader} />

          <div className="gradient-custom">
            <div className="container py-3">
              <div className="card shadow-lg border-0 mx-auto">
                <div class="card-header-custom shine-effect">
                  <h3 class="fw-bold mb-2">{courseData?.title}</h3>
                </div>
                <div className="card-body">
                  <div class="text-center mb-4">
                    <div class="mb-2">
                      {courseData?.offer_amount > 0 && (
                        <span class="original-price">
                          ₹{courseData?.actual_amount}
                        </span>
                      )}
                      <span class="price-amount">
                        ₹
                        {courseData?.offer_amount > 0
                          ? courseData?.offer_amount
                          : courseData?.actual_amount}
                      </span>
                    </div>
                    {/* <div class="discount-badge">
                      {courseData?.course_duration} Days Course
                    </div> */}
                  </div>
                  <ul className="list-unstyled mb-5">
                    {courseData?.description?.map((description, index) => (
                      <li className="mb-3" key={index}>
                        <span className="feature-icon">✓</span>
                        {description}
                      </li>
                    ))}
                  </ul>
                  <RazorpayPayment
                    courseData={courseData}
                    studentData={studentData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentPage;
